module.exports = __webpack_public_path__ + "media/white_logo/rassvet-2d659c66.png";